/**
 * Share: copy the current article URL to the clipboard, with a brief "Copied!"
 * confirmation. Falls back to execCommand when the Clipboard API is unavailable.
 */
function init($) {
    var $copyBtn = $('#blog-copy-link');
    if (!$copyBtn.length) { return; }

    $copyBtn.on('click', function () {
        var url    = window.location.href;
        var $btn   = $(this);
        var copied = $btn.data('label-copied') || 'Copied!';

        function onCopied() {
            $btn.addClass('blog-share__btn--copied').attr('aria-label', copied);
            setTimeout(function () {
                $btn.removeClass('blog-share__btn--copied')
                    .attr('aria-label', $btn.data('label-copy') || 'Copy link');
            }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(onCopied).catch(function () {});
        }
    });
}

module.exports = { init };
